import React from "react";
import BlogSection from "../components/BlogSection";

const BlogPage = () => {
  return (
    <>
      <BlogSection />
    </>
  );
};

export default BlogPage;
